import { IconButton } from '@mui/material'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { Close, Done } from '@mui/icons-material'
import GenericToggleGroup from '../../generic/buttons/toggleButtonGroups/GenericToggleGroup'
import { useState } from 'react'
import { useToggle } from '../../generic/hooks/useToggle'
import { apiDelete, apiPut, apiGet } from '../../generic/Api_Functions'
import ProfilePermissionAccordionChilds from './ProfilePermissionAccordionChilds'
import ProfileUiElementsDialog from './ProfileUiElementsDialog'
import PolicyIcon from '@mui/icons-material/Policy'
import { SmartDialog } from '../../generic/utilities/SmartDialog'

const ProfilePermission = ({ profileId, systemDefault, profileName }) => {
  const { t_ } = useSmartTranslation()
  const [uiElementsDialog, setUiElementsDialog] = useState({ open: false, profileId: null, systemDefault: true, parentPermission: null })

  const [viewAll, setViewAll] = useState('ALL')
  const [toggle, changeToogle] = useToggle()

  const toolbarButtonsInfo = {
    assigned: {
      value: 'ASSIGNED',
      color: 'info',
      content: t_('ASSIGNED')
    },
    all: {
      value: 'ALL',
      color: 'warning',
      content: t_('ALL')
    }
  }

  const sortOptions = {
    default: {
      field: 'name',
      direction: 1
    }
  }

  const toolbar = {
    render: {
      fetchFunction: () => {
        return (
          <>
            <GenericToggleGroup
              buttons={[toolbarButtonsInfo.assigned, toolbarButtonsInfo.all]}
              initialValue='ALL'
              exclusive
              onChange={(value) => {
                setViewAll(value === 'ALL')
                changeToogle()
              }}
            />
          </>
        )
      }
    }
  }

  const handleClick = async (row, field) => {
    if (row.assigned) {
      await apiDelete('profile/' + profileId + '/permission/' + row.id)
    } else {
      await apiPut('profile/' + profileId + '/permission/' + row.id)
    }
    changeToogle()
  }

  const getTableButton = (row, field) => {
    return (
      <IconButton disabled={systemDefault || !row.editable} onClick={() => handleClick(row, field)}>
        {row[field] ? <Done color='primary' /> : <Close color='error' />}
      </IconButton>
    )
  }

  const openUiElementsDialog = (row) => {
    setUiElementsDialog({ open: true, profileId: row.id, systemDefault: row.systemDefault, parentPermission: row })
  }

  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      hide: true
    },
    {
      name: t_('Name'),
      field: 'name'
    },
    {
      name: t_('Assigned'),
      field: 'assigned',
      render: row => getTableButton(row, 'assigned')
    }
  ]

  const dataFetch = async (pagination) => {
    const permissions = await apiGet('profile/' + profileId + '/nullParentPermissions/' + !viewAll, pagination)
    return permissions
  }

  const actions = {
    accordion: {
      render: (row) => {
        return <ProfilePermissionAccordionChilds parentPermission={row} profileId={profileId} systemDefault={systemDefault} viewAll={viewAll} />
      },
      hide: (row) => {
        return !row.hasAnyChild
      }
    },
    custom: [
      {
        name: t_('View UI Elements'),
        contextMenu: false,
        render: (row) => {
          if (row.hasAnyUiElement === true) {
            return (
              <IconButton onClick={() => openUiElementsDialog(row)}>
                <PolicyIcon />
              </IconButton>
            )
          }
        }
      }
    ]
  }

  return (
    <>
      <SmartDialog
        setOpen={uiElementsDialog.open}
        accept={false}
        close
        cancel={false}
        closeCallback={() => setUiElementsDialog({ ...uiElementsDialog, open: false })}
        renderComponent={
          <ProfileUiElementsDialog
            profileId={profileId}
            systemDefault={systemDefault}
            parentPermission={uiElementsDialog.parentPermission}
          />
}
      />
      <SmartMateriaUITable
        columns={columns}
        dataFetch={dataFetch}
        toolbar={toolbar}
        pageable
        forceLoad={toggle}
        resetPage={toggle}
        sortOptions={sortOptions}
        actions={actions}
        dense
      />
    </>
  )
}

export default ProfilePermission
